import React, { useEffect, useState } from "react";
import getUser from "../services/decodeJWT";
import ApiService from "../services/ApiService";
import { toBase64 } from "../services/toBase64";
import Nav from "../components/Nav";
import Loading from "../components/Loading";
import DinamicTable from "../components/DinamicTable";
import formatDate from "../services/formatDate";

const UserProfile = () => {
  const currentUser = getUser();
  const [ID, setID] = useState(null);
  const [loading, setLoading] = useState(false);

  const [profileData, setProfileData] = useState({
    name: currentUser?.username,
    firstname: "",
    lastname: "",
    country: "",
    phone: "",
    user_id: currentUser?._id || "",
  });

  const tableColumns = ["#", "Name", "Created at", "Expiring at", "Paid", "Amount"];

  const [subscriptions, setSubscriptions] = useState([]);
  const [filter, setFilter] = useState({ page: 1, pages: 0, limit: 5, isLoading: false, search: '' })
  const [activeTab, setActiveTab] = useState("profile-edit");

  const tabs = [
    { id: 'profile-edit', label: 'Edit Profile', active: true },
    { id: 'my-subscriptions', label: 'My subscriptions' },
  ];

  const getSubscriptions = async () => {
    try {
      setFilter((prev) => { return { ...prev, isLoading: true } });
      const response = await ApiService.get(`/cms/orders?page=${filter?.page}&limit=${filter?.limit}&user_id=${currentUser?._id}`);
      setFilter((prev) => { return { ...prev, pages: response?.totalPages } });
      setSubscriptions(response?.contents?.map(sub => { return { _id: sub?._id, name: sub?.data?.name, created_at: formatDate(sub?.createdAt, false), expiring_at: formatDate(sub?.data?.expiring_at, false), status: !!(sub?.data?.status == 'succeeded'), amount: `${sub?.data?.amount} ${sub?.data?.currency}` } }) || []);
    } catch (err) {
      console.error("Error fetching tasks:", err);
    } finally {
      setFilter((prev) => { return { ...prev, isLoading: false } });
    }
  };

  useEffect(() => {
    if (filter?.isLoading == false) {
      getSubscriptions();
    }
  }, [filter?.page, filter?.search]);

  const defaultProfileImage = "/images/avatar/avatar-default.jpg";
  const defaultCoverImage = "/images/cover/banner-default.png";


  const fetchProfile = async () => {
    try {
      setLoading(true);
      const response = await ApiService.get(`/cms/profiles?user_id=${currentUser?._id}`);
      if (response?.contents) {
        setID(response?.contents[0]?._id)
        setProfileData((prevState) => ({
          ...prevState,
          name: currentUser?.username,
          ...response?.contents[0]?.data
        }));
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [])

  const handleInputChange = (field, value) => {
    setProfileData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };


  const handleImageChange = async (field, file) => {

    if (!file) return;

    const base64 = await toBase64(file);

    setProfileData((prevState) => ({
      ...prevState,
      [field]: {
        name: file?.name,
        media: base64,
      },
    }));

  };

  const handleSave = async () => {

    try {
      setLoading(true);
      const payload = {
        data: profileData,
      };

      if (ID) {
        await ApiService.put(`/cms/profiles/${ID}`, payload);
      } else {
        await ApiService.post(`/cms/profiles`, payload);
      }



    } catch (error) {
      console.error("Error updating profile:", error);
    } finally {
      setLoading(false);
      fetchProfile();
      //window.location.href = "/profile";
    }
  };



  return (
    <Loading status={loading} blur={true}>
      <div className="tyn-root">
        <Nav />
        <div className="tyn-content  tyn-content-page">
          <div className="tyn-main tyn-content-inner" id="tynMain">
            <div className="container">
              <div className="tyn-profile">
                <div className="tyn-profile-head">
                  {/* Cover Image */}
                  <div className="tyn-profile-cover new-cover">
                    <img
                      className="tyn-profile-cover-image"
                      src={profileData?.cover?.media || defaultCoverImage}
                      alt="Cover"
                    />
                    {/* desktop */}
                    <label htmlFor="cover-upload" className="upload-icon-label">
                      Change Cover
                      <input
                        type="file"
                        accept="image/*"
                        id="cover-upload"
                        className="cover-upload-input"
                        onChange={(e) => handleImageChange("cover", e.target.files[0])}
                      />
                    </label>
                    {/* mobile */}
                    <label htmlFor="cover-upload" className="upload-icon-label mobile-upload">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-upload" viewBox="0 0 16 16">
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                        <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
                      </svg>
                    </label>
                  </div>

                  {/* Profile Image */}
                  <div className="tyn-profile-info">
                    <div className="tyn-media-group align-items-start">
                      <div className="tyn-media tyn-media-bordered tyn-size-4xl tyn-profile-avatar">
                        <img
                          src={profileData?.picture?.media || defaultProfileImage}
                          alt="Profile"
                        />
                        {/* desktop */}
                        <label htmlFor="avatar-upload" className="avatar-upload-label">
                          Change
                          <input
                            type="file"
                            accept="image/*"
                            id="avatar-upload"
                            className="avatar-upload-input"
                            onChange={(e) => handleImageChange("picture", e.target.files[0])}
                          />
                        </label>
                        {/* mobile */}
                        <label htmlFor="avatar-upload" className="avatar-upload-label mobile-upload">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-upload" viewBox="0 0 16 16">
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
                          </svg>
                        </label>
                      </div>
                      <div className="tyn-media-col">
                        <div className="tyn-media-row">
                          <h4 className="name text-capitalize">
                            {(profileData?.name && profileData.name.includes('@'))
                              ? profileData.name.split('@')[0]
                              : (profileData?.name || "Your Name")}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tyn-profile-nav">
                  {/* DESKTOP */}
                  <ul className="nav nav-tabs nav-tabs-line">
                    {tabs.map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                  {/* MOBILE */}
                  <div className="dropdown d-sm-none">
                    <button
                      className="btn btn-primary dropdown-toggle"
                      type="button"
                      id="tabDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {tabs.find((tab) => tab.id === activeTab)?.label || "Select"}
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-down-fill" viewBox="0 0 16 16">
                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                      </svg>
                    </button>
                    <ul className="dropdown-menu">
                      {tabs.map((tab) => (
                        <li key={tab.id}>
                          <button
                            className={`dropdown-item ${activeTab === tab.id ? "active" : ""}`}
                            onClick={() => setActiveTab(tab.id)}
                          >
                            {tab.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="tyn-profile-details">
                  <div className="tab-content">
                    {/* EDIT PROFILE TAB */}
                    <div
                      className={`tab-pane fade ${activeTab === "profile-edit" ? "show active" : ""}`}
                      id="profile-edit"
                      tabIndex="0"
                    >
                      <div className="row gy-5">
                        <div className="col-12">
                          <div className="row gy-4">
                            <div className="col-lg-3">
                              <h6>Personal Information</h6>
                              <div className="tyn-subtext">
                                Edit Your personal Info
                              </div>
                            </div>
                            <div className="col-lg-9">
                              <div className="row g-gs">

                                {/* firstname */}
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <label
                                      className="form-label"
                                      htmlFor="firstname"
                                    >
                                      First Name
                                    </label>
                                    <div className="form-control-wrap">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="firstname"
                                        placeholder="Your Name"
                                        value={profileData?.firstname || ""}
                                        onChange={(e) =>
                                          handleInputChange(
                                            "firstname",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* lastname */}
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <label
                                      className="form-label"
                                      htmlFor="lastname"
                                    >
                                      Last Name
                                    </label>
                                    <div className="form-control-wrap">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="lastname"
                                        placeholder="Your Name"
                                        value={profileData?.lastname || ""}
                                        onChange={(e) =>
                                          handleInputChange(
                                            "lastname",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* email */}
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <label
                                      className="form-label"
                                      htmlFor="lastname"
                                    >
                                      Email *
                                    </label>
                                    <div className="form-control-wrap">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="email"
                                        placeholder="Email"
                                        value={currentUser?.username || ""}
                                        disabled
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* phone */}
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <label
                                      className="form-label"
                                      htmlFor="phone"
                                    >
                                      Phone Number
                                    </label>
                                    <div className="form-control-wrap">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="phone"
                                        placeholder="Your Number"
                                        value={profileData?.phone || ""}
                                        onChange={(e) =>
                                          handleInputChange(
                                            "phone",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-12">
                                  <div className="d-flex justify-content-end buttons mt-5">
                                    <button className="btn btn-primary" onClick={handleSave}>
                                      Save Changes
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* MY SUBSCRIPTIONS TAB */}
                    <div className={`tab-pane fade ${activeTab === "my-subscriptions" ? "show active" : ""}`} id="my-subscriptions" tabIndex="0">
                      <div className="row">
                        <div>
                          <h4 className="text-capitalize center">
                            Membership List
                          </h4>
                        </div>
                        <DinamicTable data={subscriptions} tableColumns={tableColumns} filter={filter} setFilter={setFilter} search={false} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loading>
  );
};

export default UserProfile;
